/**
 * 本地缓存，提供getItem, setItem, removeItem方法;
 */

export const getItem = (name) => {
  let value = null;
  if (window.localStorage) {
    value = localStorage.getItem(name);
  } else {
    value = getCookie(name);
  }
  if (typeof value === 'string') {
    return JSON.parse(value);
  } else {
    return value;
  }
};

export const setItem = (name, value) => {
  let valueStr = JSON.stringify(value);
  if (window.localStorage) {
    localStorage.setItem(name, valueStr);
  } else {
    setCookie(name, valueStr);
  }
};

export const removeItem = (name) => {
  if (window.localStorage) {
    localStorage.removeItem(name);
  } else {
    removeCookie(name);
  }
};

const getCookie = (name) => {
  let arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
};
const setCookie = (name, value) => {
  let Days = 30;
  let exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
};
const removeCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval !== null) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
};



// WEBPACK FOOTER //
// ./src/components/util/localCache.js